import React from 'react';

import { fetchBannerDefinition, type BannerDefinition } from './banner-definition-api';

export interface BannerDefinitionState {
  /** The banner's definition once read; null while reading, or when it could not be read. */
  definition: BannerDefinition | null;
  loading: boolean;
}

/** One banner's definition (see `./banner-definition-api`), read once per banner (and brand) while the sheet is open. */
export const useBannerDefinition = (
  tenantId: number | undefined,
  bannerId: string | undefined,
): BannerDefinitionState => {
  const key = tenantId !== undefined && bannerId ? `${tenantId}|${bannerId}` : '';
  const [held, setHeld] = React.useState<{ key: string; definition: BannerDefinition | null } | null>(null);

  // Syncs with spark-creatives: one read per banner.
  React.useEffect(() => {
    if (!key || tenantId === undefined || !bannerId) return undefined;
    const ctl = new AbortController();
    void fetchBannerDefinition(tenantId, bannerId, ctl.signal).then((definition) => {
      if (!ctl.signal.aborted) setHeld({ key, definition });
    });
    return () => ctl.abort();
  }, [key, tenantId, bannerId]);

  const mine = held && held.key === key ? held : null;
  return { definition: mine?.definition ?? null, loading: key !== '' && mine === null };
};
